<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <div class="ibox row">
      <div class="ibox-title">
        <h5>Footprint Manager</h5>
      </div>
      <div class="ibox-content col-lg-12 col-md-12">
        <filters></filters>
      </div>
      <div class="col-lg-12 col-md-12 m-t-sm"></div>
      <list></list>
    </div>
  </div>
</template>
<script>
import Filters from './Filters'
import List from './List'
export default {
  mounted () {
    document.title = 'Footprint Manager :: PBN360 by Aphex Media'
  },
  components: {
    filters: Filters,
    list: List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/FootprintManager/Index.vue